import script from "./trainers-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./trainers-modal.vue?vue&type=script&setup=true&lang=js"

import "./trainers-modal.vue?vue&type=style&index=0&id=3e277c88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e277c88"]])

export default __exports__